import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import classNames from 'classnames';
import Moment from 'moment';

import IconGeneric from '../../../common/components/IconGeneric';

import ContractTypesTooltip from './ContractTypesTooltip';

class ContractTypesCalendar extends Component {
  generateClassesCalendarItem = classDirection => {
    const joinClasses = classNames(
      'contract-types__calendar-item',
      {
        'contract-types__calendar-medium': this.props.size === 'medium',
        'contract-types__calendar-small': this.props.size === 'small'
      },
      classDirection
    );

    return joinClasses;
  };

  render() {
    const classes = classNames('contract-types__calendar', {
      'contract-types__daily': this.props.type === 'daily',
      'contract-types__fortnightly': this.props.type === 'fortnightly'
    });

    let mvIn;
    let mOut;
    let crStart;
    let crEnd;
    const moment = Moment();

    if (this.props.type === 'daily') {
      mvIn = '10';
      mOut = '20';
      crStart = '10';
      crEnd = '20';
    } else if (this.props.type === 'fortnightly') {
      mvIn = '20';
      mOut = '10';
      crStart = '16';
      crEnd = '15';
    } else {
      mvIn = '10';
      mOut = '20';
      crStart = '1';
      crEnd = '30';
    }

    return (
      <div className={classes}>
        <div className="contract-types__calendar-item">
          <div className="contract-types__calendar-text">
            {moment.month(0).format('MMM')}
          </div>
        </div>
        <div
          className={this.generateClassesCalendarItem(
            'contract-types__calendar-right'
          )}
        >
          <div className="contract-types__calendar-text">
            <ContractTypesTooltip top left>
              <p className="contract-types__tooltip-title">
                {trans('contract_types.calendar.move_in')}
              </p>
              <p className="contract-types__tooltip-date">
                {mvIn} {moment.month(1).format('MMM')}
              </p>
              <IconGeneric name="angle-down" />
            </ContractTypesTooltip>
            <ContractTypesTooltip bottom left dark>
              <IconGeneric name="angle-top" />
              <p className="contract-types__tooltip-date">
                {crStart} {moment.month(1).format('MMM')}
              </p>
              <p className="contract-types__tooltip-title">
                {trans('contract_types.calendar.contract_start')}
              </p>
            </ContractTypesTooltip>
            {moment.month(1).format('MMM')}
          </div>
        </div>
        <div className="contract-types__calendar-item--separated" />
        <div
          className={this.generateClassesCalendarItem(
            'contract-types__calendar-left'
          )}
        >
          <div className="contract-types__calendar-text">
            <ContractTypesTooltip top right>
              <p className="contract-types__tooltip-title">
                {trans('contract_types.calendar.move_out')}
              </p>
              <p className="contract-types__tooltip-date">
                {mOut} {moment.month(10).format('MMM')}
              </p>
              <IconGeneric name="angle-down" />
            </ContractTypesTooltip>
            {moment.month(10).format('MMM')}
          </div>
          <ContractTypesTooltip bottom right dark>
            <IconGeneric name="angle-top" />
            <p className="contract-types__tooltip-date">
              {crEnd} {moment.month(10).format('MMM')}
            </p>
            <p className="contract-types__tooltip-title">
              {trans('contract_types.calendar.contract_end')}
            </p>
          </ContractTypesTooltip>
        </div>
        <div className="contract-types__calendar-item">
          <div className="contract-types__calendar-text">
            {moment.month(11).format('MMM')}
          </div>
        </div>
      </div>
    );
  }
}

ContractTypesCalendar.propTypes = {
  type: PropTypes.oneOf(['daily', 'monthly', 'fortnightly']).isRequired,
  size: PropTypes.oneOf(['medium', 'small']).isRequired
};

export default ContractTypesCalendar;
